module.exports = __webpack_public_path__ + "static/media/icono_negro.2dce7575.png";